// @flow
import React, { type Node } from 'react';
import './CategoriesTemplate.scss';

type Props = {
  children: Node,
};

const CategoriesTemplate = ({ children }: Props) => (
  <div className="CategoriesTemplate">{children}</div>
);

export default CategoriesTemplate;



// WEBPACK FOOTER //
// ./src/components/categories/CategoriesTemplate/CategoriesTemplate.js